define(function(require) {
	// general
	const CN = require('civicsUtils/constants');
	const InstrumentUtils = require('civicsUtils/instrument_utilities');
	const Utils = require('civicsUtils/general_utilities');
	const ViewManager = require('civicsUtils/view_manager');
	// models
	const CdrLogModel = require('civicsModels/cdr_log_model');
	// templates
	const tpl = require('civicsViews/assign_review/templates/t_itv_review_cancel_assignment.hbs');

	return Marionette.ItemView.extend({
		initialize: function(options) {
			this.config = options.config;
			this.model = options.model;
			this.modalRegion = options.modalRegion;
		},
		onRender:function(){
			this.$el.rhythmThemeInit();
		},
		onDomRefresh: function() {
			this.ui.message.maxlength();
		},
		template: tpl,
		className: 'review-detail-modal',
		events: {
			'click @ui.btnBack': 'backClicked',
			'click @ui.btnClose': 'backClicked',
			'click @ui.btnCancelAssignment': 'cancelAssignmentClicked',
		},
		ui:{
			btnBack: '.btn-back-confirmation',
			btnClose:'.bbm-btn-close',
			btnCancelAssignment: '.btn-cancel-confirmation',
			message: '#message'
		},
		enableButtons: function(enable){
			this.ui.btnBack.prop('disabled', !enable);
			this.ui.btnCancelAssignment.prop('disabled', !enable);
		},
		backClicked:function(){
			if(__DEV__) console.log('itv cancel assignment -- backClicked');

			this.triggerMethod('back:clicked');

			if(this.modalRegion) {
				this.modalRegion.hideModal();
			}
			else {
				this.destroy();
			}
		},
		cancelAssignmentClicked: function cancelAssignmentClicked() {
			if (__DEV__) console.log('itv cancel assignment -- logOperation, operationType: ', this.config.operationType);
			var self = this;
			ViewManager.loading(true);
			var data = ViewManager.fromWindow(this);
			var log = new CdrLogModel();
			var now = new Date($.now());
			var dataType = this.config.instrumentType;
			var saveData = {};
			saveData.application = this.model.get('application.id');
			saveData.review = this.model.get('id');
			saveData.logType = ViewManager.globalConfig().get(dataType + '.' + this.config.operationType + 'ReviewLogType');
			saveData.StartDateTime = now.yyyymmdd();
			saveData.comments = data.message;
			log._dataType = dataType;
			log.save(saveData)
			.done(function (response, status, xhrResponse) {
				if (__DEV__) console.log('itv cancel review assignment -- save Log done before save review model');

				self.model.formatUrlRoot(self.config.instrumentType);
				self.model.set({
					'assignedToProvider': { id: 1 },
					'scheduledDateTime': CN.DATE_TIME_MIN_VAL
				});
				self.model.unset("attachments", { silent: true }); //Do not send Attachments, there is no need to since we can't update them.
				self.model.unset("reviewAttachments", { silent: true });

				self.model.save(null, {
					error: function error(model, response, options) {
						ViewManager.errorToWindow(response, this);
						ViewManager.loading(false);
						self.enableButtons(true);
					}
				}).done(function (response, status, xhrResponse) {
					ViewManager.loading(false);
					if (__DEV__) console.log('itv cancel review assignment -- cancelAssignment done function after save review model');
					if (self.modalRegion) {
						self.modalRegion.hideModal();
					} else {
						self.destroy();
					}

					self.triggerMethod('cancelReviewAssignmentConfirmation:clicked');
				}).fail(function (response, status, xhrResponse) {
					ViewManager.errorToWindow(response, this);
					ViewManager.loading(false);
					self.enableButtons(true);
				});
			}).fail(function (response, status, xhrResponse) {
				ViewManager.loading(false);
				if(response.responseJSON.responseStatus.message.indexOf('You do not have access to add a log to this instrument') != -1) {
					ViewManager.openAlert( i18n.t('CIVICS.ASSIGN_REVIEW.DO_NOT_HAVE_ACCESS_ERROR') );
				}
				else {
					ViewManager.errorToWindow(response, this);
				}
				self.enableButtons(true);
			});
		},
		templateHelpers: function(){
			var self = this;
			return {
				modelId: this.model.get('id'),
				isCancel: this.config.operationType == 'cancel',
				hasSite: self.config.instrumentType != 'tradeLicense',
				modalTitle: ((this.config.operationType == 'cancel') ? i18n.t('CIVICS.ASSIGN_REVIEW.CANCEL_REVIEW') : i18n.t('CIVICS.ASSIGN_REVIEW.DECLINE_REVIEW')),
				cancelButtonTitle: ((this.config.operationType == 'cancel') ? i18n.t('CIVICS.ASSIGN_REVIEW.CANCEL_REVIEW') : i18n.t('CIVICS.ASSIGN_REVIEW.DECLINE_REVIEW'))
			};
		}
	});
});
